import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ServiceType } from '../../../models/service-type.model';
import { ServiceTypeService } from '../../../services/service-type/service-type.service';


@Component({
  selector: 'app-service-type-form',
  templateUrl: 'serviceTypeForm.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})

export class ServiceTypeFormComponent implements OnChanges, OnInit {
  @Output() serviceTypeAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() serviceTypeUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output() endSaveOrUpdate = new EventEmitter<boolean>();
  @Input() dialogBoxServiceType: ServiceType;
  addEditForm: FormGroup;
  invalidSubmit: boolean;
  validation: any;

  constructor(
    private fb: FormBuilder,
    private srvServiceType: ServiceTypeService
  ) { }

  ngOnInit(): void {
    this.srvServiceType.getFields().subscribe(res => {
      this.validation = res;
    });
  }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
        name: new FormControl(this.dialogBoxServiceType.name),
        description : new FormControl(this.dialogBoxServiceType.description)
    });
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    let newData = {...this.dialogBoxServiceType, ...this.addEditForm.value};
    if (newData.id) {
      this.serviceTypeUpdated.emit(newData);
    } else {
      this.serviceTypeAdded.emit(newData);
    }
    this.endSaveOrUpdate.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/service-type/serviceTypeForm.component.ts